/**
 * Supplier Quote Requests (RFQ responses).
 * Status: Pending | Received | Accepted | Declined
 */
export const supplierQuotes = [
  {
    id: 'sqr-001',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000003', // INC10063
    ticketNumber: 'INC10063',
    partNumber: 'RAM-32GB-DDR5',
    sentDate: '2026-03-18',
    supplierName: 'Vantage Technology Supply',
    supplierEmail: 'rsimmons@vantagetech.com',
    quantityRequested: 1,
    unitCost: 295.00,
    notes: 'In stock, can ship same day.',
    status: 'Received',
  },
  {
    id: 'sqr-002',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000003', // INC10063
    ticketNumber: 'INC10063',
    partNumber: 'RAM-32GB-DDR5',
    sentDate: '2026-03-18',
    supplierName: 'Crestline Distribution',
    supplierEmail: 'tferreira@crestlinedist.com',
    quantityRequested: 1,
    unitCost: 312.50,
    notes: 'Limited stock — recommend ordering soon.',
    status: 'Received',
  },
  {
    id: 'sqr-003',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000003', // INC10063
    ticketNumber: 'INC10063',
    partNumber: 'RAM-32GB-DDR5',
    sentDate: '2026-03-18',
    supplierName: 'Bridgepoint Components',
    supplierEmail: 'lchow@bridgepointcomp.com',
    quantityRequested: 1,
    unitCost: null,
    notes: null,
    status: 'Pending',
  },

  // ── INC10188 — HBA-16G-FC (BioCore Research Labs / ClearPath Solutions) ──
  {
    id: 'sqr-004',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000016', // INC10188
    ticketNumber: 'INC10188',
    partNumber: 'HBA-16G-FC',
    sentDate: '2026-04-02',
    supplierName: 'Crestline Distribution',
    supplierEmail: 'tferreira@crestlinedist.com',
    quantityRequested: 1,
    unitCost: 818.00,
    notes: '8 units on hand. Ready to ship within 24hrs of PO.',
    status: 'Received',
  },
  {
    id: 'sqr-005',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000016', // INC10188
    ticketNumber: 'INC10188',
    partNumber: 'HBA-16G-FC',
    sentDate: '2026-04-02',
    supplierName: 'Pinnacle Technology Group',
    supplierEmail: 'kpatel@pinnacletg.com',
    quantityRequested: 1,
    unitCost: 849.00,
    notes: 'Stock available in Greenville SC.',
    status: 'Received',
  },
  {
    id: 'sqr-006',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000016', // INC10188
    ticketNumber: 'INC10188',
    partNumber: 'HBA-16G-FC',
    sentDate: '2026-04-02',
    supplierName: 'Bridgepoint Components',
    supplierEmail: 'lchow@bridgepointcomp.com',
    quantityRequested: 1,
    unitCost: null,
    notes: null,
    status: 'Pending',
  },

  // ── INC10125 — NIC-10G-RJ45 (Pacific Rim Technologies) — Accepted ──────────
  {
    id: 'sqr-007',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000009',
    ticketNumber: 'INC10125',
    partNumber: 'NIC-10G-RJ45',
    sentDate: '2026-03-25',
    supplierName: 'Bridgepoint Components',
    supplierEmail: 'lchow@bridgepointcomp.com',
    quantityRequested: 1,
    unitCost: 218.00,
    notes: 'In stock at Centennial DC. Can ship same business day.',
    status: 'Accepted',
  },
  {
    id: 'sqr-008',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000009',
    ticketNumber: 'INC10125',
    partNumber: 'NIC-10G-RJ45',
    sentDate: '2026-03-25',
    supplierName: 'Vantage Technology Supply',
    supplierEmail: 'rsimmons@vantagetech.com',
    quantityRequested: 1,
    unitCost: 234.00,
    notes: null,
    status: 'Declined',
  },
  {
    id: 'sqr-009',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000009',
    ticketNumber: 'INC10125',
    partNumber: 'NIC-10G-RJ45',
    sentDate: '2026-03-25',
    supplierName: 'Crestline Distribution',
    supplierEmail: 'tferreira@crestlinedist.com',
    quantityRequested: 1,
    unitCost: 241.50,
    notes: 'High stock availability. Bulk pricing available on 5+ units.',
    status: 'Declined',
  },

  // ── INC10172 — SSD-3840-NVMe (BioCore Research Labs) — Responses in, awaiting decision ──
  {
    id: 'sqr-010',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000014',
    ticketNumber: 'INC10172',
    partNumber: 'SSD-3840-NVMe',
    sentDate: '2026-03-31',
    supplierName: 'Crestline Distribution',
    supplierEmail: 'tferreira@crestlinedist.com',
    quantityRequested: 1,
    unitCost: 1295.00,
    notes: 'Enterprise SKU confirmed. Ships from Irvine CA.',
    status: 'Received',
  },
  {
    id: 'sqr-011',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000014',
    ticketNumber: 'INC10172',
    partNumber: 'SSD-3840-NVMe',
    sentDate: '2026-03-31',
    supplierName: 'Vantage Technology Supply',
    supplierEmail: 'rsimmons@vantagetech.com',
    quantityRequested: 1,
    unitCost: 1340.00,
    notes: 'Limited qty. Recommend confirming before end of week.',
    status: 'Received',
  },
  {
    id: 'sqr-012',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000014',
    ticketNumber: 'INC10172',
    partNumber: 'SSD-3840-NVMe',
    sentDate: '2026-03-31',
    supplierName: 'Bridgepoint Components',
    supplierEmail: 'lchow@bridgepointcomp.com',
    quantityRequested: 1,
    unitCost: null,
    notes: null,
    status: 'Pending',
  },

  // ── INC10165 — NIC-10G-RJ45 (Summit Data Centers) — Early stage, 1 response in ──
  {
    id: 'sqr-013',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000013',
    ticketNumber: 'INC10165',
    partNumber: 'NIC-10G-RJ45',
    sentDate: '2026-04-03',
    supplierName: 'Crestline Distribution',
    supplierEmail: 'tferreira@crestlinedist.com',
    quantityRequested: 1,
    unitCost: 229.00,
    notes: null,
    status: 'Received',
  },
  {
    id: 'sqr-014',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000013',
    ticketNumber: 'INC10165',
    partNumber: 'NIC-10G-RJ45',
    sentDate: '2026-04-03',
    supplierName: 'Pinnacle Technology Group',
    supplierEmail: 'kpatel@pinnacletg.com',
    quantityRequested: 1,
    unitCost: null,
    notes: null,
    status: 'Pending',
  },
  {
    id: 'sqr-015',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000013',
    ticketNumber: 'INC10165',
    partNumber: 'NIC-10G-RJ45',
    sentDate: '2026-04-03',
    supplierName: 'Vantage Technology Supply',
    supplierEmail: 'rsimmons@vantagetech.com',
    quantityRequested: 1,
    unitCost: null,
    notes: null,
    status: 'Pending',
  },
];
